<template>
  <a :class="classList" href="#" @click.prevent.stop="onActionClick">
    <icon width="18" height="18" v-if="icon" :name="icon"></icon>
  </a>
</template>

<script>
export default {
  name: "TableRowAction",
  props: {
    icon: String,
    active: [Boolean, Number],
    highlightStroke: Boolean,
  },
  name: "tr-action",

  computed: {
    classList() {
      return {
        "c-tr-action": true,
        "is-active": this.active,
        "highlight-stroke": this.highlightStroke,
      };
    },
  },

  methods: {
    onActionClick(e) {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
.c-tr-action {
  height: 100%;
  padding: 0;

  .svg-icon {
    fill: #c9ced4;
  }

  &:hover .svg-icon {
    fill: $colour-cactus-bright-green;
  }

  &.is-active .svg-icon {
    fill: $colour-cactus-bright-green;
  }

  &.highlight-stroke {
    &:hover .svg-icon path{
      fill: $colour-cactus-bright-green;
      stroke: $colour-cactus-bright-green;
    }
    &.is-active .svg-icon path{
      fill: $colour-cactus-bright-green;
      stroke: $colour-cactus-bright-green;
    }
  }
}
</style>
